import { REGIONS } from "../constants/constants";
import { isEmpty } from "lodash";

export const isEarlyMarketEmpty = (earlyMarket) =>
  earlyMarket &&
  (earlyMarket.imagePath === "" ||
    earlyMarket.syndicationCommodities?.every((commodity) => commodity.percentageChange?.trim() === ""));

export const isPreviousEmpty = (previous, productLineId) =>
  previous && (previous.imagePath === "" || previous.content?.trim() === "") && productLineId !== 3;

export const isMarketOverviewEmpty = (marketOverview) =>
  marketOverview && marketOverview.marketOverviewSections?.every((overview) => overview.content?.trim() === "");

export const isOutSideMarketEmpty = (outsideMarkets) => outsideMarkets && outsideMarkets.content?.trim() === "";

export const isWeatherEmpty = (region, weather) => {
  let isInvalidWeatherContent = false;
  if (region !== REGIONS.SA && weather) {
    const { precipitationImage, temperatureImage, content } = weather;
    // If content is empty then weather section is invalid
    if (isEmpty(content)) {
      return true;
    }
    // if either precipitation and temperature image is empty then weather section is invalid
    if ("precipitationImage" in weather || "temperatureImage" in weather) {
      isInvalidWeatherContent = isEmpty(precipitationImage) && isEmpty(temperatureImage);
    }
    // if region is SA_ES or SA_PG then check for image1, image2, image3, image4, atleast 1 image should be present
    const { image1, image2, image3, image4 } = weather;
    if (region === REGIONS.SA_ES || region === REGIONS.SA_PG) {
      isInvalidWeatherContent = isEmpty(image1) && isEmpty(image2) && isEmpty(image3) && isEmpty(image4);
    }
  }
  return isInvalidWeatherContent;
};

export const isAdvertisementLinkEmpty = (syndicationAdvertisementBanner) =>
  syndicationAdvertisementBanner.redirectLink === "" || syndicationAdvertisementBanner.imagePath === "";

export function getYaxisConfig(
  pos,
  id,
  labelStyle,
  tickStyle,
  drawOnChartArea,
  stepSize = {},
  afterBuildCb = false,
  labelFormat = (label) => label
) {
  return {
    type: "linear",
    display: true,
    position: pos,
    id: id,
    title: {
      display: labelStyle.display,
      text: labelStyle.title,
      color: labelStyle.color,
    },
    ticks: {
      autoSkip: true,
      color: tickStyle.color,
      font: {
        style: tickStyle.weight,
        size: tickStyle.size,
      },
      ...stepSize,
      // maxTicksLimit: 20,
      callback: (label) => {
        let formattedLabel = labelFormat(label);
        if (tickStyle.label) {
          return "  " + tickStyle.label + formattedLabel + "  ";
        }
        return formattedLabel;
      },
    },
    grid: {
      tickMarkLength: 7,
      zeroLineColor: "green",
      display: true,
      drawOnChartArea: drawOnChartArea,
      // zerolineWidth : 10,
      lineWidth: 2,
    },
    afterBuildTicks: function (axis) {
      if (axis.id === id && afterBuildCb) {
        if (axis.ticks) {
          let minTick = axis.ticks[0];
          if (minTick) {
            let newMin = minTick.value - (stepSize.stepSize ?? 0);
            let minVal = newMin < -1 ? 0 : newMin;
            axis.ticks.unshift({ value: minVal });
            axis.min = minVal;
          }
        }
      }
    },
  };
}
